import clsx from "clsx";
import type { InlineSwitcherProps } from "./types";
import { SwitcherItem } from "./SwitcherItem";

export const InlineSwitcher = <T extends string>({
  value,
  options,
  onChange,
  variant = "text",
  className,
  listClassName,
  itemClassName,
  activeItemClassName,
  separator = <span className="text-gray-300">•</span>,
}: InlineSwitcherProps<T>) => {
  const isSegmented = variant === "segmented";

  return (
    <div className={clsx("overflow-x-auto", className)}>
      <div
        className={clsx(
          isSegmented
            ? "flex w-full items-center gap-0.5 rounded-lg bg-gray-100 p-0.5"
            : "flex items-center gap-2 whitespace-nowrap min-w-max",
          listClassName,
        )}
      >
        {options.map((opt, idx) => {
          const isActive = opt.value === value;

          return (
            <div
              key={opt.value}
              className={clsx(
                "flex items-center",
                isSegmented ? "flex-1" : "gap-2",
              )}
            >
              <SwitcherItem
                variant={variant}
                isActive={isActive}
                isDisabled={opt.disabled}
                label={opt.label}
                onClick={() => onChange(opt.value)}
                itemClassName={itemClassName}
                activeItemClassName={activeItemClassName}
              />

              {!isSegmented && idx < options.length - 1 && separator}
            </div>
          );
        })}
      </div>
    </div>
  );
};
